import { InlineText3 } from '@cian/ui-kit/typography';

import cn from 'classnames';
import * as React from 'react';

import { TagNewProps } from './types';

const styles = require('./TagNew.css');

export const TagNew: React.FC<TagNewProps> = props => {
  const { containerClassName } = props;

  return (
    <div className={cn(styles['container'], containerClassName)}>
      <InlineText3 color="white_100">Новое</InlineText3>
    </div>
  );
};

TagNew.displayName = 'TagNew';
